<template>
 <div class="bg-neutral-100">
    <section id="main-container" class="container eoi-main-container page-container">
      <div >
       
        <div class="row" v-if="!isLoading && listing">
          <div class="eoi-wrapper">
            <section class="eoi-header">
              <h5 class="eoi-location text-secondary text-3xl md-text-3xl xl2-text-4xl ">{{listing.region}}</h5>
              <h6 class="eoi-currency text-secondary text-3xl md-text-3xl xl2-text-4xl">
                {{
                  parseFloat(listing.price) ? `$${listing.price}` : "EOI"
                }} <span class="">
                    {{ listing.currency }}</span>
                <span v-if="['Sold', 'Under Contract'].includes(listing.status)" class="status-label text-secondary m-left-10"
                  >({{ listing.status }})
                </span>
              </h6>
              <span class="text-secondary font-bold text-lg xl2-text-lg">
                {{ listing.include_gst ? 'Includes GST' : '' }}
              </span>
            </section>

            <section class="eoi-reference-section">
              <p class="text-reference text-xl xl2-text-xl"><strong>Ref: {{ listing?.reference }}</strong></p>
              <p class="text-description text-lg xl2-text-lg" v-html="listing?.rent_roll_details"></p>
              <br />
              <p class="text-optional-details text-lg xl2-text-lg"><strong>{{ listing?.optional_details_label }}</strong></p>
              <p class="text-description text-lg xl2-text-lg" v-html="listing?.optional_details_data"></p>
            </section>

            <section class="eoi-info-cards">
              <div class="col-md-4">
                <div class="info-card">
                  <div class="info-icon text-xl xl2-text-4xl">
                    <i class="fa fa-home text-4xl xl2-text-4xl"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label text-lg xl2-text-lg">Number of Managements</div>
                    <div class="info-value text-secondary text-3xl md-text-4xl xl2-text-5xl">{{listing?.total_properties}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-card">
                  <div class="info-icon text-xl xl2-text-4xl">
                    <i class="fa fa-money text-4xl xl2-text-4xl"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label text-lg xl2-text-lg">Annual management fees</div>
                    <div class="info-value text-secondary text-3xl md-text-4xl xl2-text-5xl">${{ amountFormatChange(listing?.management_fee_income || 0)}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-card">
                  <div class="info-icon text-xl xl2-text-4xl">
                    <i class="fa fa-dollar text-4xl xl2-text-4xl"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label text-lg xl2-text-lg">Historic 12 Month Gross Income</div>
                    <div class="info-value text-secondary text-3xl md-text-4xl xl2-text-5xl">${{ amountFormatChange(listing?.gross_income || 0) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-card">
                  <div class="info-icon text-xl xl2-text-4xl">
                    <i class="fa fa-key text-4xl xl2-text-4xl"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label text-lg xl2-text-lg">Average Rent</div>
                    <div class="info-value text-secondary text-3xl md-text-4xl xl2-text-5xl">${{ amountFormatChange(listing?.average_rent || 0) }} pw</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-card">
                  <div class="info-icon text-xl xl2-text-4xl">
                    <i class="fa fa-home text-4xl xl2-text-4xl"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label text-lg xl2-text-lg">Average Management Fee</div>
                      <div class="info-value text-secondary text-3xl md-text-4xl xl2-text-5xl">${{ amountFormatChange(listing?.average_management_fee || 0) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="info-card">
                  <div class="info-icon text-xl xl2-text-4xl">
                    <i class="fa fa-percent text-4xl xl2-text-4xl"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label text-lg xl2-text-lg">Average Management %</div>
                    <div class="info-value text-secondary text-3xl md-text-4xl xl2-text-5xl">{{ percentageFormatChange(listing?.average_management_fee_residential || 0) }}%</div>
                  </div>
                </div>
              </div>
            </section>

            <section class="eoi-register-section">
              <h3 class="register-title text-secondary text-3xl md-text-4xl xl2-text-5xl">Register Your Interest</h3>
              <p class="register-description text-lg xl2-text-lg">
                To register your interest, either log in or create an account below. You will then be directed to a confidentiality agreement.
                Once submitted, you'll gain instant online access to this portfolio's comprehensive information memorandum. One of our brokers
                will also be in touch within 48 business hours.
              </p>

              <div v-if="!loggedIn && !email_verified_at" class="register-login-options">
                <a :href="loginUrl" class="btn  bg-accent project-info-label custom-btn text-black text-lg xl2-text-lg">
                  <i class="fa fa-user-o project-info-label"></i> Log In
                </a>
                <div class="or-divider text-lg xl2-text-lg">or</div>
                <p class="text-lg xl2-text-lg">To create an account please enter your email address.</p>

                <div class="row">
                  <div class="col-md-4">
                    <input type="email" v-model="email" class="form-control border-radius-8 height-40 margin-bottom-10" placeholder="Enter your email address" />
                  </div>
                  <div class="col-md-4">
                    <button class="btn bg-accent text-black project-info-label custom-btn text-lg xl2-text-lg" @click="checkEmail">Submit</button>
                  </div>
                </div>
              </div>

              <div v-if="(listing.status === 'For Sale' && (loggedIn || email_verified_at))" class="enquiry-form">
                <!-- <div class="row">
                  <div :key="refreshKey" class="col-md-12"> -->
                    <p v-show="!email_verified_at" class="text-lg xl2-text-lg"><strong class="confirm-details">Please confirm your details below</strong><br /><br /></p>
                    <CustomerForm
                      enquiry
                      interest="registered_buyer"
                      :listing="id"
                      :key="refreshKey"
                      remove-agency
                      :values="customerRegistrationForm"
                      help-link="https://www.youtube.com/embed/Zw6ReiTRopA"
                      :email_verified_at="email_verified_at"
                    />
                  <!-- </div>
                </div> -->
              </div>
            </section>
          </div>
         </div>
      </div>
    </section>
  </div>
</template>

<script>
import { geoLocations, listings, identities } from "@/lib/axios";
import CustomerForm from "@/components/CustomerForm";
import { mapGetters, mapActions } from "vuex";
import get from "lodash-es/get"
import { getCookie } from '@/utils/helpers'

export default {
  props: {
    email_verified_at: [Boolean, String],
    verified_email: String,
    listing_login: [Boolean, String]
  },
  components: {
    CustomerForm
  },
  computed: {
    getGeoLocations() {
      return geoLocations;
    },
    ...mapGetters('auth', {
      loggedIn: 'loggedIn',
      user: 'user',
      customer: 'customer',
    }),
    sectionOne() {
      return (
          this.listing &&
          (parseFloat(this.listing.average_management_fee_residential) ||
              parseFloat(this.listing.average_management_fee_commercial) ||
              parseFloat(this.listing.average_management_fee_holiday) ||
              parseFloat(this.listing.average_management_fee_strata))
      );
    },
    sectionTwo() {
      return (
          this.listing &&
          (parseFloat(this.listing.management_fee_income) ||
              parseFloat(this.listing.gross_income) ||
              parseFloat(this.listing.average_rent) ||
              parseFloat(this.listing.average_management_fee))
      );
    }
  },
  data() {
    const getListingIdByRoute = this.$route.params.id;
    return {
      id: getListingIdByRoute,
      listing_id: getListingIdByRoute,
      listing: null,
      fields: {},
      errors: {},
      success: false,
      isLoading: false,
      categoryData: [],
      email: "",
      emailValue: 'email',
      isAvailable: false,
      loginUrl: `${process.env.VUE_APP_ADMIN_URL}/login?redirect=${process.env.VUE_APP_ADMIN_URL}/rent-roll-listings/${this.$route.params.id}`,
      customerRegistrationForm: this.getDefaultCustomerRegistrationForm(getListingIdByRoute),
      refreshKey: 0,
      states: [
        {value: "residential", label: "Residential", icon: "fa fa-home"},
        {value: "commercial", label: "Commercial", icon: "fa fa-building"},
        {value: "holiday", label: "Holiday", icon: "fa fa-plane"},
        {value: "strata", label: "Strata", icon: "fa fa-building"}
      ],
    };
  },
  async mounted () {
    if(this.loggedIn){
      let getAuthUser = null;
      const getAuthUserCookie = getCookie('getAuthUser');
      if(getAuthUserCookie){
        getAuthUser = getAuthUserCookie;
      }
      if(!getAuthUser && this.user){
        getAuthUser = this.user;
      }
      
      if(getAuthUser?.isCustomer){
        const customerResponse = await this.getCustomer(getAuthUser?.customer?.id);
        if(customerResponse){
          this.customer = customerResponse;
          this.populateCustomerRegistrationForm(customerResponse);
          this.refreshKey++;
        }
      }
    }
    if(this.listing_login){
      setTimeout(() => {
        this.populateCustomerRegistrationForm(this.customer);
        this.refreshKey++
      },5000)
    }

    if (this.email_verified_at){
      Object.assign(this.customerRegistrationForm, {
        email: this.verified_email,
      })
    }
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.loadListingPerId();
  },
  methods: {
    ...mapActions('auth', {
      getCustomer: 'getCustomer',
    }),
    async loadListingPerId() {
      this.isLoading = true;
      try {
        const { data } = await listings.get(`/listings/${this.id}`);
        this.listing = data.data;
        this.isLoading = false;
      } catch (e) {
        console.log(e, "e");
        this.isLoading = false;
      }
    },
    handleDropdownChange(value, name) {
      this.categoryData[name] = value.id;
    },
    async checkEmail() {
      try {
        const { data } = await identities.post(`api/find-email`, { "email": this.email });
        this.isAvailable = data.success;
        if (this.isAvailable) {
          window.location.href = `${this.loginUrl}&available_email=${this.email}`;
        }else {
          window.location.href = `${process.env.VUE_APP_ADMIN_URL}/email-otp-verification?non_user=${this.email}&listing_ulid=${this.$route.params.id}`
        }
      } catch (e) {
        this.errors = {
          ...this.errors,
          business: get(e, "response.data.errors"),
          ...get(e, "response.data.errors")

        };
      }
    },
    getDefaultCustomerRegistrationForm(listingId) {
      return {
        registered_buyer: 'Yes',
        registered_seller: 'No',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        business_role: '',
        listing_id: listingId,
        non_user: 'Yes',
        company_id: '',
        business: {
          trading_name: '',
          name: '',
          abn: '',
          street_address: '',
          suburb: '',
          state_id: '',
          postcode: '',
          country_id: '',
        }
      };
    },
    populateCustomerRegistrationForm(customer) {
      const customerContact = get(customer, 'contact', {});
      const customerBusiness = get(customer, 'business', {});
      const customerCompany = get(customer, 'company', {});

      Object.assign(this.customerRegistrationForm, {
        first_name: customerContact.first_name,
        registered_buyer: 'Yes',
        registered_seller: customer.registered_seller || 'No',
        last_name: customerContact.last_name,
        email: customerContact.email,
        phone_number: customerContact.phone_number,
        business_role: customerContact.business_role,
        listing_id: this.id,
        non_user: "No",
        company_id: customerCompany.id,
        business: {
          trading_name: customerBusiness.trading_name,
          name: customerBusiness.name,
          abn: customerBusiness.abn,
          street_address: customerBusiness.street_address,
          suburb: customerBusiness.suburb,
          state_id: customerBusiness.state_id,
          postcode: customerBusiness.postcode,
          country_id: customerBusiness.country_id,
        }
      });
    },
    amountFormatChange(value){

      if(value){
        let valArr = value.split('.')
        return valArr[0]
      }
      return 0;
    },
    percentageFormatChange(value){
      if(value){
        if(parseFloat(value)%1 === 0){
          return parseFloat(value);
        }
        return parseFloat(value).toFixed(2);
      }
      return 0;
    }

  }
};
</script>

<style scoped>
@media (min-width: 768px) {
  
  .info-label {
    margin-bottom: 20px;
  }
  .eoi-location {
    margin-bottom: 20px;
  }
  .eoi-currency {
    margin-bottom: 20px;
  }
  
}
.eoi-wrapper {
  font-family: 'Helvetica Neue', sans-serif;
  color: #333;
  padding: 20px;
}


.eoi-currency {
  margin-bottom: 20px;
}
.eoi-reference-section {
  margin-bottom: 30px;
}

.info-card {
  background-color: #1c1531;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  color: #fff;
  width: 100%;
  height: 100%;
}
.info-label {
  color: #ccc;
}
.info-card .info-value {
  font-weight: bold;
  margin-top: 10px;
  font-size: 44px;
}
.info-icon {
  margin-bottom: 10px;
}


.register-description {
  margin-bottom: 20px;
  color: #444;
}
.or-divider {
  margin: 20px 0;
  font-weight: bold;
  color: #777;
}
.p-15 {
  padding: 15px;
}

.gap-40 {
  height: 40px;
}

.gap-20 {
  height: 20px;
}


.font-white {
  color: white;
}

.listing-links {
  color: #8e44ad;
  text-decoration: none;
}

.listing-links:hover {
  color: #732d91;
  text-decoration: none;
}
.bg-accent {
  --tw-bg-opacity: 1;
  background-color: rgb(204 212 233 / var(--tw-bg-opacity, 1));
}
.custom-btn {
  border: none !important;
  border-radius: 8px !important;
  /* width: 80px; */
  padding: 10px 30px !important;
}
.border-radius-8 {
  border-radius: 8px !important;
}
.height-40 {
  height: 40px !important;
}
.margin-bottom-10 {
  margin-bottom: 10px !important;
}
section{
  padding: 20px 10px !important;
}
h5,h6{
  font-weight: normal !important;
}
/* p{
  font-size: large !important;
} */
.bg-neutral-100{
  --tw-bg-opacity: 1;
  background-color: rgb(238 236 235 / var(--tw-bg-opacity, 1)) !important;
}
h3,h4,h5,h6{
  font-weight: normal !important;
  text-transform: none !important;
}
.eoi-info-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* Optional: space between cards */
  margin-left: 64px;
  margin-right: 64px;
}
.eoi-info-cards > .col-md-4 {
  flex: 1 1 300px; /* Grow, shrink, min width */
  max-width: 32%;  /* 3 cards per row on desktop */
  min-width: 250px;
  display: flex;
}
.text-optional-details {
  font-size: 18px !important;

}


@media (max-width: 768px) {
  .eoi-info-cards > .col-md-4 {
    max-width: 100%;
    min-width: 100%;
  }
}
.eoi-info-cards .col-md-4{
  padding: 0px !important;
}
</style>
